export enum ContractStatus {
  draft = 'draft',
  intent = 'intent',
  finalized = 'finalized',
  externallyManaged = 'externally_managed',
  completed = 'completed',
  canceled = 'canceled'
}
